import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-paid-ads',
  imports: [CommonModule, RouterLink],
  templateUrl: './paid-ads.html',
  styleUrl: './paid-ads.css'
})
export class PaidAds {
  features = [
    {
      title: 'Google Ads Management',
      description: 'Search, Display, Shopping, and YouTube campaigns optimized for maximum ROI.',
      icon: 'google'
    },
    {
      title: 'Meta Ads (Facebook & Instagram)',
      description: 'Targeted social advertising with advanced audience segmentation and creative testing.',
      icon: 'meta'
    },
    {
      title: 'LinkedIn Advertising',
      description: 'B2B lead generation with precise professional targeting and thought leadership campaigns.',
      icon: 'linkedin'
    },
    {
      title: 'Programmatic Advertising',
      description: 'Automated media buying across premium publishers with real-time optimization.',
      icon: 'programmatic'
    },
    {
      title: 'Retargeting & Remarketing',
      description: 'Re-engage website visitors and past customers with personalized ad experiences.',
      icon: 'retargeting'
    },
    {
      title: 'Landing Page Optimization',
      description: 'High-converting landing pages designed for your campaigns with continuous A/B testing.',
      icon: 'landing'
    }
  ];

  process = [
    { step: 1, title: 'Audit & Strategy', description: 'We analyze your current campaigns, competitors, and market to develop a winning strategy.' },
    { step: 2, title: 'Campaign Setup', description: 'Build optimized campaign structures with precise targeting and compelling creative.' },
    { step: 3, title: 'Launch & Monitor', description: 'Go live with real-time monitoring and rapid optimization based on performance data.' },
    { step: 4, title: 'Scale & Optimize', description: 'Continuously improve performance while scaling successful campaigns for growth.' }
  ];

  caseStudy = {
    client: 'CloudTech Solutions',
    industry: 'B2B SaaS',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
    challenge: 'CloudTech was spending $50,000/month on Google Ads with declining returns. Their cost per lead had increased 40% year-over-year while lead quality suffered.',
    solution: 'We restructured their campaigns using our proprietary ROAS optimization framework, implemented advanced audience targeting, and created new ad creatives aligned with buyer intent signals.',
    results: [
      { metric: '68%', description: 'Reduction in Cost Per Lead' },
      { metric: '245%', description: 'Increase in Qualified Leads' },
      { metric: '4.2x', description: 'Return on Ad Spend' },
      { metric: '35%', description: 'Improvement in Lead Quality Score' }
    ]
  };

  testimonial = {
    quote: 'HoneyKode completely transformed our paid advertising. We went from wasting money on unqualified clicks to having a predictable, scalable lead generation machine. The ROI speaks for itself.',
    author: 'David Martinez',
    role: 'VP of Marketing',
    company: 'CloudTech Solutions',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  };

  platforms = [
    { name: 'Google Ads', logo: 'https://www.gstatic.com/images/branding/product/2x/ads_192dp.png' },
    { name: 'Meta', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Meta_Platforms_Inc._logo.svg/200px-Meta_Platforms_Inc._logo.svg.png' },
    { name: 'LinkedIn', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/100px-LinkedIn_logo_initials.png' },
    { name: 'Twitter/X', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/X_logo_2023_original.svg/100px-X_logo_2023_original.svg.png' },
    { name: 'TikTok', logo: 'https://sf-tb-sg.ibytedtos.com/obj/eden-sg/uhtyvueh7nulogpoguhm/tiktok-icon2.png' },
    { name: 'Microsoft Ads', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/100px-Microsoft_logo.svg.png' }
  ];
}
